import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Search from "../../components/Search";
import Multiselectsearch from "../../components/MultiSearchDropdown";
import { DropdownDatepicker } from "../../components/DropdownwithDatepicker";
import ModalDialog from "../../components/ModalDialog";
import { useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { ArrowSwap20Regular, Dismiss24Regular } from "@fluentui/react-icons";
import {
  MaterialReactTable,
  MRT_RowSelectionState,
  MRT_SortingState,
  type MRT_ColumnDef,
} from "material-react-table";

import { RootState } from "../../redux/store";
import {
  Divider,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  OverlayDrawer,
  Toaster,
  makeStyles,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogContent,
} from "@fluentui/react-components";
import apiServices from "../../service";
import { MRT_PaginationState } from "material-react-table";
import ReactQuillComponent from "../../components/ReactQuillComponent";
import ActionListForm from "./ActionListForm";
import { debounce } from "lodash";
import {
  convertStringToArray,
  formatedDate,
  formatedTime,
  isObjectEmpty,
} from "../../utils";
import {
  openActionListDetailPopup,
  setActionListSelectedItem,
} from "../../redux/appSettingsSlice";
import ContentLoader from "../../components/Loader/ContentLoader";
import { getCustomerReview } from "./Services";
import { TableListLoader } from "../../components/Loader/TableListLoader";
import ASCButton from "../../components/Button";
import defaultTableConfig from "../../shared/tableConfig.json";
import {
  fetchUserPreferences,
  savePreferences,
  selectDefaultConfig,
  selectPreferenceStatus,
  selectTableColumnOrder,
  selectTableColumns,
  setTableColumnOrder,
} from "../../redux/userPreferenceSlice";
import { useToastMessage } from "../../components/ToastMessage/ToastMessage";
import ActionListDetails from "./actionListDetails";
interface PropsType {
  setTabs?: Dispatch<SetStateAction<string>>;
}
const useStyles = makeStyles({
  divider: {
    flexGrow: 0,
  },
});
interface RowItem {
  case_type: string;
  business_category: number;
  itemId: string;
  customer_id: string;
  case_id: string;
  category: string;
}
const List = ({ setTabs }: PropsType) => {
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [updateReminder, setUpdateReminder] = useState(false);
  const [actionListItems, setActionListItems] = useState<any>([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [option, setOption] = useState<string>(
    "category=asset_bank_review&category=asset_shares_review&category=asset_investment_review&category=asset_investment&category=asset_home_review&category=credit_review_date&category=loan_review_date&category=mortgage_review_date&category=policy_review_date&category=client_action&category=case_tracking_action&category=client_review&category=bithday"
  );
  const [rowCount, setRowCount] = useState(0);
  const [optionDate, setOptionDate] = useState("next31DaysOverdue");
  const [optionDateValue, setOptionDateValue] = useState(
    "Next 31 Days Plus Overdue"
  );
  const [isLoadingSkeleton, setIsLoadingSkeleton] = useState(false);
  const [selectedDropDownValues, setSelectedDropDownValues] = useState<
    string[]
  >([]);

  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 200,
  });
  const [columnOrder, setColumnOrder] = useState<string[]>([]);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [isDetailDataLoading, setIsDetailDataLoading] = useState(false);
  const [isDetailLoading, setIsDetailLoading] = useState(true);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);
  const loggedUser = useSelector((state: RootState) => state.authUser);
  const appSettings = useSelector((state: RootState) => state.appSettings);
  const [selectedConsultantValues, setSelectedConsultantValues] = useState<
    string[]
  >([]);
  const [consultantOptions, setConsultantOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [clearTriggered, setClearTriggered] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [activeRowItem, setActiveRowItem] = useState<any | {}>({});
  const [activeRowItemDetail, setActiveRowItemDetail] = useState<any | {}>({});
  const [activeUpdateRowItemDetail, setActiveUpdateRowItemDetail] = useState<
    any | {}
  >({});
  const [assigneeOptions, setAssigneeOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [selectedAssigneeValues, setSelectedAssigneeValues] = useState<
    string[]
  >([]);

  const [selectedActionCategories, setSelectedActionCategories] = useState<any>(
    [
      "asset_home_review",
      "credit_review_date",
      "mortgage_review_date",
      "loan_review_date",
      "policy_review_date",
      "client_review",
      "client_action",
      "asset_bank_review",
      "case_tracking_action",
      "asset_investment_review",
      "asset_shares_review",
      "birthday",
    ]
  );
  const actionCategories = useMemo(
    () => [
      { label: "Client Action", value: "client_action" },
      { label: "Asset (Banks) Review", value: "asset_bank_review" },
      { label: "Asset (Home/Person)", value: "asset_home_review" },
      {
        label: "Asset (Investment) Review",
        value: "asset_investment_review",
      },
      { label: "Asset (Shares) Review", value: "asset_shares_review" },
      { label: "Case Tracking Action", value: "case_tracking_action" },
      { label: "Client Review", value: "client_review" },
      { label: "Credit Card Review Date", value: "credit_review_date" },
      { label: "Loan Review Date", value: "loan_review_date" },
      { label: "Mortgage Review Date", value: "mortgage_review_date" },
      { label: "Policy Review Date", value: "policy_review_date" },
      { label: "Birthday", value: "birthday" },
    ],
    []
  );
  const CaseCateoryListMaping: any = {
    "Unit-linked": "Asset(Investment) Review",
    "Banks/B Societies": "Asset(Banks) Review",
    Shares: "Asset(Shares) Review",
    "Home/Personal": "Asset(Home) Review",
    "Life Assurance": "Policy Review Date",
    Pensions: "Policy Review Date",
    Investements: "Policy Review Date",
    "Savings Plans": "Policy Review Date",
    "Income Protection": "Policy Review Date",
    "Health Assurance": "Policy Review Date",
    General: "Policy Review Date",
    Mortgages: "Mortgage Review Date",
    "Loans/Lease/HP": "Loan Review Date",
    "Credit Cards": "Credit Card Review Date",
  };
  const caseCategoryMap: any = {
    "Asset(Banks) Review": apiServices.assets.getDetail,
    "Asset(Home) Review": apiServices.assets.getDetail,
    "Asset(Investment) Review": apiServices.assets.getDetail,
    "Asset(Shares) Review": apiServices.assets.getDetail,
    "Credit Card Review Date": apiServices.liability.getDetail,
    "Loan Review Date": apiServices.liability.getDetail,
    "Mortgage Review Date": apiServices.liability.getDetail,
    "Policy Review Date": apiServices.policy.getDetail,
  };
  const businessCategoryMap: {
    [key: number]: (itemId: string, customerId: string) => Promise<any>;
  } = {
    2: apiServices.assets.getDetail,
    6: apiServices.liability.getDetail,
    7: apiServices.liability.getDetail,
    1: apiServices.policy.getDetail,
  };

  function dateSelection(item: any) {
    setOptionDate(item);
  }
  function dateLabel(item: any) {
    setOptionDateValue(item);
  }
  // --------------- table config - ACTION_LIST ---------------
  const tableName = "ACTION_LIST";
  const columns = useSelector(selectTableColumns(tableName));
  const reduxColumnOrder = useSelector(selectTableColumnOrder(tableName));
  const defaultConfig = useSelector(selectDefaultConfig);
  const preferenceStatus = useSelector(selectPreferenceStatus);
  const reduxColumns = useSelector(selectTableColumns(tableName));
  const userPreferences = useSelector(
    (state: RootState) => state.userPreferences?.preferences
  );
  const defaultColumns =
    defaultTableConfig.tables.contextSpecific[tableName]?.columns || [];
  const tables = useSelector(
    (state: RootState) =>
      state.userPreferences?.preferences?.tables || {
        defaultConfig: {},
        contextSpecific: {},
      }
  );
  const contextSpecific = useSelector(
    (state: RootState) =>
      state.userPreferences?.preferences?.tables?.contextSpecific || {}
  );
  const tableSettings = useSelector(
    (state: RootState) =>
      state.userPreferences?.preferences?.tables?.contextSpecific?.[
        tableName
      ] || {}
  );
  const tableInitialState = useSelector(
    (state: RootState) =>
      state.userPreferences?.preferences?.tables?.contextSpecific?.[tableName]
        ?.initialState || {}
  );

  useEffect(() => {
    if (preferenceStatus === "idle") {
      dispatch(fetchUserPreferences());
    }
  }, [preferenceStatus]);
  useEffect(() => {
    const savedOrder =
      reduxColumnOrder.length > 0
        ? reduxColumnOrder
        : columns.map((col: any) => col.accessorKey);

    if (JSON.stringify(savedOrder) !== JSON.stringify(columnOrder)) {
      setColumnOrder(savedOrder);
      setHasChanges(false); // Reset changes when loading saved order
    }
  }, [reduxColumnOrder, columns, columnOrder]);

  const customColumns = useMemo<MRT_ColumnDef<any>[]>(() => {
    if (!reduxColumns || reduxColumns.length === 0) {
      return [];
    }

    return reduxColumns.map((col: any) => {
      const enhancedCol: MRT_ColumnDef<any> = { ...col };

      if (typeof col.Cell === "string") {
        switch (col.Cell) {
          case "formatedDate":
            enhancedCol.Cell = ({ row }) => (
              <>{formatedDate(row.original[col.accessorKey])}</>
            );
            break;
          case "formatedTime":
            enhancedCol.Cell = ({ row }) => (
              <>{formatedTime(row.original[col.accessorKey])}</>
            );
            break;
          case "ReactQuillComponent":
            enhancedCol.Cell = ({ row }) => (
              <ReactQuillComponent value={row.original[col.accessorKey]} />
            );
            break;
          default:
            enhancedCol.Cell = ({ row }) => (
              <>{row.original[col.accessorKey]}</>
            );
            break;
        }
      } else if (typeof col.Cell === "function") {
        enhancedCol.Cell = col.Cell;
      }

      return enhancedCol;
    });
  }, [reduxColumns]);

  const config = useMemo(
    () => ({
      ...defaultConfig,
      enablePagination: true,
      enableColumnOrdering: true,
      enableColumnDragging: true,
      initialState: {
        ...defaultConfig.initialState,
        density: "compact" as const,
        columnOrder,
        columnPinning: { right: ["mrt-row-actions"] },
      },
    }),
    [defaultConfig, columnOrder]
  );
  const handleColumnOrderChange = (
    updater: string[] | ((prev: string[]) => string[])
  ) => {
    const newOrder =
      typeof updater === "function" ? updater(columnOrder) : updater;
    setColumnOrder(newOrder);
    const isChanged =
      JSON.stringify(newOrder) !== JSON.stringify(reduxColumnOrder);
    setHasChanges(isChanged);
    dispatch(setTableColumnOrder({ tableName, columnOrder: newOrder }));
  };

  useEffect(() => {
    setColumnOrder((prevColumnOrder) => {
      let updatedOrder = [...prevColumnOrder];

      if (!updatedOrder.includes("mrt-row-select")) {
        updatedOrder.push("mrt-row-select");
      }

      return prevColumnOrder === updatedOrder ? prevColumnOrder : updatedOrder;
    });
  }, []);
  const handleSavePreference = async () => {
    setIsProcessing(true);
    const updatedSettings = {
      ...userPreferences,
      tables: {
        ...tables,
        contextSpecific: {
          ...contextSpecific,
          [tableName]: {
            ...tableSettings,
            initialState: {
              ...tableInitialState,
              columnOrder: columnOrder?.length
                ? columnOrder
                : tableInitialState?.columnOrder,
            },
          },
        },
      },
    };

    const isUpdatedSettingsEmpty =
      !updatedSettings ||
      Object.keys(updatedSettings).length === 0 ||
      !updatedSettings.tables ||
      Object.keys(updatedSettings.tables).length === 0;

    const finalSettings = isUpdatedSettingsEmpty
      ? defaultTableConfig
      : updatedSettings;
    // const finalSettings = defaultTableConfig;
    try {
      const { message } = await dispatch(
        savePreferences(finalSettings)
      ).unwrap();
      showToast(message, "", "success");
      setIsProcessing(false);
      setHasChanges(false);
    } catch (error) {
      setIsProcessing(false);
      console.error("Error saving preferences:", error);
    }
  };
  useEffect(() => {
    const columnsReady = Array.isArray(columns) && columns.length > 0;
    const defaultReady =
      Array.isArray(defaultColumns) && defaultColumns.length > 0;

    if (
      columnsReady &&
      defaultReady &&
      JSON.stringify(columns) !== JSON.stringify(defaultColumns)
    ) {
      savePreferencesAutomatically();
    }
  }, [columns, defaultColumns]);

  const savePreferencesAutomatically = useRef(
    debounce(async () => {
      try {
        const { message } = await dispatch(
          savePreferences(defaultTableConfig)
        ).unwrap();
      } catch (error) {
        console.error("Error saving preferences:", error);
      }
    }, 500)
  ).current;
  // --------------- table config - ACTION_LIST --------------- end

  // --------------- api ---------------

  const getCustomerDetail = (customerId: string) => {
    fetchClientDetail(apiServices.client.getDetail, customerId);
  };

  const getCustomerActionDetail = (customerId: string, actionId: string) => {
    apiServices.contactClientAction
      .getById(actionId, customerId)
      .then((response: any) => {
        setIsDetailDataLoading(false);
        if (
          response.data &&
          !response.data.isError &&
          !isObjectEmpty(response.data.data)
        ) {
          setActiveUpdateRowItemDetail({
            date: response.data.data.appointment_date,
            time: response.data.data.appointment_time,
            type: response.data.data.appointment_type,
            description: response.data.data.appointment_note,
            assigned: response.data.data.appointment_assigned,
            status: response.data.data.appointment_status,
            category: "Client Action",

            customer_id: customerId,
            appointment_id: actionId,
            case_type: activeRowItem.case_type,
          });
        }
      })
      .catch((err: any) => {
        console.log(err);
        setIsDetailDataLoading(false);
      });
  };

  const getConsultantOptions = async () => {
    setIsLoadingSkeleton(true);
    try {
      const response = await apiServices.actionList.getConsultant(
        loggedUser.userId
      );
      if (Array.isArray(response.data.data)) {
        const consultantData = response.data.data.map((consultant: string) => ({
          label: consultant,
          value: consultant,
        }));
        setConsultantOptions(consultantData);
      } else {
        showToast("Something went wrong", "", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Something went wrong", "", "error");
    } finally {
      setIsLoadingSkeleton(false);
    }
  };

  const getAssigneeOptions = async () => {
    setIsLoadingSkeleton(true);
    try {
      const response = await apiServices.actionList.getAssignee(
        loggedUser.userId
      );
      if (Array.isArray(response.data.data)) {
        const assigneeData = response.data.data.map((assignee: string) => ({
          label: assignee,
          value: assignee,
        }));
        setAssigneeOptions(assigneeData);
      } else {
        showToast("Something went wrong", "", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Something went wrong", "", "error");
    } finally {
      setIsLoadingSkeleton(false);
    }
  };

  const getActionListData = async () => {
    if (selectedActionCategories.length > 0) {
      setLoading(true);
      try {
        const response = await apiServices.actionList.listItems(
          loggedUser.userId,
          pagination.pageIndex + 1,
          pagination.pageSize,
          optionDate,
          selectedActionCategories,
          selectedConsultantValues,
          selectedAssigneeValues,
          search
        );
        if (response?.data?.data) {
          await setRowCount(response?.data ? response.data.count : 0);

          if (response?.data?.data?.length > 0) {
            const resultData = response.data.data;

            setLoading(false);
            setActionListItems(resultData);
          } else {
            setActionListItems("");
          }
          setLoading(false);
        } else {
          showToast(response.data.error, "", "error");
          setLoading(false);
          return;
        }
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    }
  };

  const getItemDetail = async (row: any) => {
    setIsDetailDataLoading(true);
    setActiveRowItem(row);
    if (!isObjectEmpty(row)) {
      let activeRowItem = row;
      if (activeRowItem.category === "Client Action") {
        getCustomerActionDetail(
          activeRowItem.customer_id,
          activeRowItem.case_id
        );
      } else if (activeRowItem.category === "Client Review") {
        setIsDetailDataLoading(true);
        const customerReview = await getCustomerReview(
          activeRowItem.customer_id
        );

        if (customerReview) {
          setIsDetailDataLoading(false);
          setActiveUpdateRowItemDetail({
            review_interval: customerReview.review_interval,
            review_reason: customerReview.review_note,
            review_assigned: customerReview.review_assigned,
            review_completed: customerReview.review_completed,
            consultant_id: customerReview.consultant_id,
            consultant: customerReview.consultant,
            review_date: customerReview.review_date,
            category: "Client Review",
            customer_id: activeRowItem.customer_id,
            case_type: activeRowItem.case_type,
          });
        } else {
          setIsDetailDataLoading(false);
        }
      } else if (activeRowItem.category === "Case Tracking Action") {
        setActiveUpdateRowItemDetail({
          action_date: activeRowItem.action_date,
          description: activeRowItem.description,
          assigned: activeRowItem.assigned,
          status: activeRowItem.status,
          category: "Case Tracking Action",
          case_id: activeRowItem.case_id,
          customer_id: activeRowItem.customer_id,
          business_category: activeRowItem.business_category,
          case_type: activeRowItem.case_type,
          business_id: activeRowItem.business_id,
        });
        setIsDetailDataLoading(false);
      } else {
        getCaseDetail(activeRowItem);
        setIsDetailDataLoading(false);
      }
    }
  };
  const fetchClientDetail = (
    apiCall: (customerId: string) => Promise<any>,
    customerId: string
  ) => {
    apiCall(customerId)
      .then((response: any) => {
        setIsDetailLoading(false);
        if (
          response.data &&
          !response.data.isError &&
          !isObjectEmpty(response.data.data)
        ) {
          setActiveRowItemDetail(response.data.data);
        }
      })
      .catch((err) => {
        setIsDetailLoading(false);
        console.log(err);
      });
  };
  const getCaseDetail = (rowItem: RowItem) => {
    const apiCall = caseCategoryMap[rowItem.category];

    if (apiCall) {
      fetchDetail(apiCall, rowItem.case_id, rowItem.customer_id);
    } else {
      setIsDetailLoading(false);
      console.error("No matching case_type found");
    }
  };

  const getCaseActionDetails = (rowItem: RowItem) => {
    const apiCall = businessCategoryMap[rowItem.business_category];
    if (apiCall) {
      fetchDetail(apiCall, rowItem.case_id, rowItem.customer_id);
    } else {
      setIsDetailLoading(false);
      console.error("No matching business_category found");
    }
  };
  const fetchDetail = (
    apiCall: (itemId: string, customerId: string) => Promise<any>,
    itemId: string,
    customerId: string
  ) => {
    apiCall(itemId, customerId)
      .then(handleSuccessResponse)
      .catch(handleErrorResponse);
  };
  const handleSuccessResponse = (response: any) => {
    setIsDetailLoading(false);
    if (
      response.data &&
      !response.data.isError &&
      !isObjectEmpty(response.data.data)
    ) {
      setActiveRowItemDetail(response.data.data);
      setActiveUpdateRowItemDetail({
        date: response.data.data.review_date,
        review_interval: response.data.data.review_interval,
        review_reason: response.data.data.review_reason,
        review_assigned: response.data.data.review_assigned,
        category: CaseCateoryListMaping[response.data.data.case_type] || "",
        case_type: response.data.data.case_type || "",
        review_completed: response.data.data.review_completed,
        customer_id: response.data.data.customer_id,
        caseId:
          response.data?.data?.policy_id ||
          response.data?.data?.liability_id ||
          response.data?.data?.asset_id ||
          "",
        owner:
          response.data?.data?.policy_holder ||
          response.data?.data?.joint_indicator ||
          0,
      });
    } else if (response.data.isError) {
      if (
        response.data.error &&
        Object.keys(response.data.error).length !== 0
      ) {
        let errorMessage = "";

        if (Array.isArray(response.data.error.message)) {
          errorMessage = response.data.error.message.join("\n"); // Join all error messages
        } else {
          errorMessage = response.data.error.message;
        }

        showToast(errorMessage, "", "error");
      }
    } else {
      showToast("Something went wrong", "", "error");
    }
  };
  const handleErrorResponse = (err: any) => {
    setIsDetailLoading(false);
    console.log(err);
    showToast(err.message, "", "error");
  };

  const ClearFilter = () => {
    setSelectedConsultantValues([]);
    setSelectedAssigneeValues([]);
    setSelectedActionCategories(actionCategories.map((c: any) => c.value));
    setOptionDate("next31DaysOverdue");
    setOptionDateValue("Next 31 Days Plus Overdue");
    setSearch("");
    setPagination({ pageIndex: 0, pageSize: 200 });
    setClearTriggered(true);
  };
  const hasAnyFilterApplied = useMemo(() => {
    return (
      selectedActionCategories.length < 12 ||
      selectedConsultantValues.length > 0 ||
      selectedAssigneeValues.length > 0 ||
      optionDate !== "next31DaysOverdue" ||
      search !== ""
    );
  }, [
    selectedActionCategories,
    selectedConsultantValues,
    selectedAssigneeValues,
    optionDate,
    search,
  ]);

  useEffect(() => {
    const newOption = selectedConsultantValues.join("&");
    setOption(newOption);
  }, [selectedConsultantValues]);

  useEffect(() => {
    if (appSettings?.actionListDetailPopup) {
      if (!isObjectEmpty(activeRowItem)) {
        setIsDetailLoading(true);
        setActiveRowItemDetail([]);
        if (
          activeRowItem.category === "Client Action" ||
          activeRowItem.category === "Client Review" ||
          activeRowItem.category === "Birthday"
        ) {
          getCustomerDetail(activeRowItem.customer_id);
        } else if (activeRowItem.category === "Case Tracking Action") {
          getCaseActionDetails(activeRowItem);
        } else {
          getCaseDetail(activeRowItem);
        }
      }
    }
  }, [appSettings?.actionListDetailPopup]);

  useEffect(() => {}, [activeUpdateRowItemDetail, activeRowItem]);

  useEffect(() => {
    if (loggedUser?.userId !== null && selectedActionCategories.length > 0) {
      getActionListData();
    }
  }, [loggedUser?.userId, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    if (clearTriggered) {
      getActionListData();
      setClearTriggered(false);
    }
  }, [clearTriggered]);

  useEffect(() => {
    if (
      actionListItems.length > 0 &&
      Object.keys(rowSelection)[0] !== undefined
    ) {
      let index = Object.keys(rowSelection)[0];
      let selectedRow = actionListItems[index];
      setActiveRowItem(selectedRow);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (Object.keys(activeRowItem).length !== 0) {
      dispatch(setActionListSelectedItem(activeRowItem));
    }
  }, [activeRowItem]);
  useEffect(() => {
    let newOption = selectedDropDownValues.join("&");
    setOption(newOption);
  }, [selectedDropDownValues]);

  return (
    <>
      {loading ? (
        <TableListLoader rows={10} columns={6} />
      ) : (
        <div className="page-content-area">
          <Toaster toasterId={toasterId} position="top-end" timeout={5000} />

          <div className="action-list-wrapper">
            <MaterialReactTable
              enableStickyHeader={config.enableStickyHeader}
              defaultColumn={{
                maxSize: 100,
              }}
              enableColumnResizing={config.enableColumnResizing}
              columnResizeMode={"onEnd"}
              renderTopToolbarCustomActions={({ table }) => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <div className="acionlist_filter">
                    <Search
                      placeholder="Search"
                      setSearch={setSearch}
                      search={search}
                      isLoading={loading}
                    />
                    <Multiselectsearch
                      setSelectedDropDownValues={setSelectedActionCategories}
                      selectedDropDownValues={selectedActionCategories}
                      placeholder="Choose by Action Category"
                      options={actionCategories}
                      allSelectedText="All categories"
                    />
                    <DropdownDatepicker
                      dateSelection={dateSelection}
                      dateLabel={dateLabel}
                      optionDateValue={optionDateValue}
                      optionDate={optionDate}
                    />
                    <Multiselectsearch
                      setSelectedDropDownValues={setSelectedConsultantValues}
                      selectedDropDownValues={selectedConsultantValues}
                      placeholder="Consultants"
                      options={consultantOptions}
                      onOpenChange={(e, data) => {
                        if (data.open) {
                          getConsultantOptions();
                        }
                      }}
                      allSelectedText="All Consultants"
                    />
                    <Multiselectsearch
                      setSelectedDropDownValues={setSelectedAssigneeValues}
                      selectedDropDownValues={selectedAssigneeValues}
                      placeholder="Assigned"
                      options={assigneeOptions}
                      onOpenChange={(e, data) => {
                        if (data.open) {
                          getAssigneeOptions();
                        }
                      }}
                      allSelectedText="All Assignees"
                    />

                    <ASCButton
                      shape="rounded"
                      className="asc-button-primary fill_button"
                      appearance="primary"
                      onClick={() => {
                        getActionListData();
                      }}
                      disabled={selectedActionCategories.length === 0}
                      label="Apply filter"
                    />
                    {hasAnyFilterApplied && (
                      <ASCButton
                        shape="rounded"
                        className="asc-button-primary fill_button"
                        appearance="primary"
                        onClick={ClearFilter}
                        label="Clear filter"
                      />
                    )}
                  </div>
                  {convertStringToArray(
                    process.env.REACT_APP_HIDE_CTA_BUTTON
                  ).includes("action_list_preference") && (
                    <ASCButton
                      shape="rounded"
                      className="asc-button-secondary"
                      appearance="secondary"
                      onClick={handleSavePreference}
                      label="Save Preference"
                      disabled={!hasChanges || isProcessing}
                    />
                  )}
                </div>
              )}
              columns={customColumns}
              data={actionListItems}
              enableExpandAll={config.enableExpandAll}
              enableExpanding={config.enableExpanding}
              enableRowSelection={config.enableRowSelection}
              enableColumnActions={config.enableColumnActions}
              enableColumnOrdering={config.enableColumnOrdering}
              enableColumnDragging={config.enableColumnDragging}
              onColumnOrderChange={handleColumnOrderChange}
              enableSorting={config.enableSorting}
              manualSorting={config.manualSorting}
              enablePagination={config.enablePagination}
              enableMultiRowSelection={config.enableMultiRowSelection}
              enableColumnFilters={config.enableColumnFilters}
              enableGlobalFilter={config.enableGlobalFilter}
              enableDensityToggle={config.enableDensityToggle}
              manualFiltering={config.manualFiltering}
              initialState={config.initialState}
              muiTableProps={config.muiTableProps}
              muiTableHeadCellProps={config.muiTableHeadCellProps}
              onRowSelectionChange={setRowSelection}
              state={{
                rowSelection: rowSelection,
                pagination,
                columnOrder,
                sorting,
              }}
              onSortingChange={setSorting}
              muiTableBodyRowProps={({ row }: any) => ({
                ...config.muiTableBodyRowProps,
                onDoubleClick: () => {
                  if (row.original?.category != "Birthday") {
                    setRowSelection({ [row.index]: true });
                    setActiveRowItem(row.original);
                    getItemDetail(row.original);

                    setUpdateReminder(true);
                  }
                },
                sx: { cursor: "pointer" },
              })}
              icons={{
                DragHandleIcon: () => (
                  <ArrowSwap20Regular
                    style={{ color: "000", cursor: "grab" }}
                  />
                ),
              }}
              positionToolbarAlertBanner="bottom"
              manualPagination
              onPaginationChange={setPagination}
              rowCount={rowCount}
              muiTablePaginationProps={{
                rowsPerPageOptions: [10, 50, 100, 200, 500],
              }}
            />
          </div>

          <ModalDialog
            options={dialogModalOptions}
            getActionListData={getActionListData}
          />
          <OverlayDrawer
            position="end"
            open={appSettings?.actionListDetailPopup}
            onOpenChange={(_, { open }) =>
              dispatch(openActionListDetailPopup(open))
            }
            style={{ width: "450px", marginTop: "130px" }}
          >
            <DrawerHeader>
              <DrawerHeaderTitle
                action={
                  <ASCButton
                    shape="rounded"
                    appearance="subtle"
                    aria-label="Close"
                    icon={<Dismiss24Regular />}
                    onClick={() => dispatch(openActionListDetailPopup(false))}
                  />
                }
              >
                {activeRowItem.category}
              </DrawerHeaderTitle>
            </DrawerHeader>
            <Divider className={styles.divider} />
            <DrawerBody>
              {isDetailLoading ? (
                <ContentLoader />
              ) : (
                <ActionListDetails
                  activeRowItem={activeRowItem}
                  activeRowItemDetail={activeRowItemDetail}
                />
              )}
            </DrawerBody>
          </OverlayDrawer>
          <Dialog open={updateReminder} modalType="non-modal">
            <DialogSurface aria-modal="false">
              <DialogBody>
                <DialogContent>
                  <ActionListForm
                    data={activeUpdateRowItemDetail}
                    showToast={showToast}
                    cancelPopup={() => {
                      setUpdateReminder(false);
                    }}
                    getActionListData={getActionListData}
                    isDetailDataLoading={isDetailDataLoading}
                    activeRowItem={activeRowItem}
                  />
                </DialogContent>
              </DialogBody>
            </DialogSurface>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default List;
